import * as React from 'react';
import { ConfigurationsState } from 'Common/appshell_types/remoteConfigType';

export const OneHeaderContext = React.createContext<ConfigurationsState>({} as ConfigurationsState);
const { Provider, Consumer } = OneHeaderContext;
export { Consumer as ConfigurationsConsumer };

interface OneHeaderProviderProps {
    initialConfigurations: ConfigurationsState;
    children: React.ReactNode;
}

const OneHeaderProvider = ({ children, initialConfigurations }: OneHeaderProviderProps) => (
    <Provider value={initialConfigurations}>{children}</Provider>
);

export default OneHeaderProvider;
